import { render, staticRenderFns } from "./IncomeSourcesSelectorControl.vue?vue&type=template&id=be4f4d9e&"
import script from "./IncomeSourcesSelectorControl.vue?vue&type=script&lang=js&"
export * from "./IncomeSourcesSelectorControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports